import { usersApi } from "@/lib";
import z from "zod";

export const userSchema = z.object({
	id: z.string().optional(),
	name: z.string().nonempty("Bắt buộc nhập").max(255, "Tối đa 255 ký tự"),
	email: z
		.string()
		.nonempty("Bắt buộc nhập")
		.max(150, "Tối đa 150 ký tự")
		.regex(/^[^@\s]+@vlu\.edu\.vn$/i, "Email không hợp lệ"),
	currentEmail: z.string().optional(), // Dùng để so sánh khi edit
	username: z.string().nonempty("Bắt buộc nhập").max(255, "Tối đa 255 ký tự").regex(/^\S+$/, "Không khoảng trắng"),
	role: z.enum(["", "admin", "user", "viewer"]),
	status: z.enum(["active", "inactive", "suspended"]),
	department: z.string(),
	position: z.string(),
	phone: z.string(),
	permissions: z.array(z.string()),
}).superRefine(async (data, ctx) => {
	if (/^[^@\s]+@vlu\.edu\.vn$/i.test(data.email) == false) return;

	const { currentEmail, email } = data;
	let exists = false;
	if (!currentEmail && email) {

		exists = await checkEmailExists(email);
	} else {
		if (!email) return

		if (email && currentEmail == email) {
			return; // Success (bỏ qua check API)
		}

		exists = await checkEmailExists(email);
	}

	// Logic check: Nếu exists là TRUE (đã tồn tại), thì THẤT BẠI
	if (exists) {
		ctx.addIssue({
			code: z.ZodIssueCode.custom,
			message: "Email đã tồn tại",
			path: ["email"], // Chỉ định lỗi vào trường nào
		});
		return; // Validation thất bại
	}
});

async function checkEmailExists(email: string): Promise<boolean> {
	const response = await usersApi.checkExist({ email });
	return response as unknown as boolean;
}

export type UserSchemaType = z.infer<typeof userSchema>;